import angular from 'angular';

export default function JobSchedulerService($http, appSettings, JobSchedulerMockService) {
  'ngInject';
  if (appSettings.FixturesModeEnabled) {
    return JobSchedulerMockService;
  }

  this.createSchedule = function(schedule) {
    let endpoint = `${appSettings.InReachApiReportEndpoint}/schedules`;
    let req;
    if (schedule) {
      req = {
        method: 'POST',
        url: endpoint,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(schedule.data)
      }; //end req
    }

    return $http(req);
  };

  let dateRangeTranslationTable = {
    '7d': '7 days',
    MTD: 'Month to date',
    '30d': 'Last 30 Days',
    '90d': 'Last 90 Days'
  };

  let frequencyTranslationTable = {
    day: 'Occurs Daily',
    month: 'Occurs Monthly',
    year: 'Occurs Yearly'
  };

  this.getEquipmentList = function(schedule) {
    return schedule.equipment;
  };

  this.getDateRange = function(schedule, translated) {
    let dropDownDates = [
      {
        id: 1,
        label: '7d',
        reportName: 'Last 7 Days',
        tooltip: 'Last 7 Days'
      },
      {
        id: 2,
        label: 'MTD',
        reportName: 'Month-To-Date',
        tooltip: 'Month-To-Date'
      },
      {
        id: 3,
        label: '30d',
        reportName: 'Last 30 Days',
        tooltip: 'Last 30 Days'
      },
      {
        id: 4,
        label: '90d',
        reportName: 'Last 90 Days',
        tooltip: 'Last 90 Days'
      }
    ];
    let dateRangeParsed = dropDownDates[schedule.reportParameters.drop_DateRange - 1];
    if (!translated) {
      return dateRangeParsed;
    }

    let translatedValue = dateRangeTranslationTable[dateRangeParsed.label];

    if (!translated) {
      translatedValue = dateRangeParsed.reportName;
    }

    if (!translated) {
      translatedValue = dateRangeParsed.label;
    }

    return translatedValue;
  };

  this.getScheduleRecurrenceFrequency = function(schedule, translated) {
    if (!translated) {
      return schedule.recurrence.frequency;
    }

    return frequencyTranslationTable[schedule.recurrence.frequency];
  };

  this.getNotificationEmails = function(schedule) {
    if (!schedule) return null;
    let arr = [];
    try {
      angular.forEach(schedule.contacts, function(email) {
        arr.push(email.email);
      });
    } catch (e) {
      return null;
    }

    return arr;
  };

  this.updateSchedule = function(schedule) {
    let endpoint = `${appSettings.InReachApiReportEndpoint}/schedules/${schedule.id}`; // InReachApiSchedulerEndpoint
    let req = {
      method: 'PUT',
      url: endpoint,
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(schedule.data)
    }; //end req
    return $http(req);
  };

  //Gets a schedules report path
  this.getScheduleReportPath = function(schedule) {
    return schedule.reportPath;
  };

  this.getSchedules = function(typeName) {
    let endpoint = `${appSettings.InReachApiReportEndpoint}/schedules?tag=${typeName}`; //&attr[type]=report; attrs:{  "type":"report" } [reportName]
    return $http.get(endpoint);
  };

  this.getSchedule = function(id) {
    //schedules/{id}
    let endpoint = `${appSettings.InReachApiReportEndpoint}/schedules/${id}`; //&attr[type]=report; attrs:{  "type":"report" } [reportName]
    return $http.get(endpoint);
  };

  this.deleteSchedule = function(schedule) {
    if (!schedule) return;
    let endpoint = `${appSettings.InReachApiReportEndpoint}/schedules/${schedule.id}`;
    return $http.delete(endpoint);
  };
}
